import { RefObject, useEffect } from 'react';

/*  This hook applies the sticky polyfill to a given component upon it mounting, and 
    removes it again on unmount
*/
export const useSticky = (refElement: RefObject<HTMLElement>): void => {
  useEffect(() => {
    /* Required to fix server-side issue with Stickyfill.  Stickyfill does not initiialize 
       correctly on the server, so we load it in clientside code
    */
    // eslint-disable-next-line global-require,@typescript-eslint/no-var-requires
    const Stickyfill = require('stickyfilljs');

    /* Stickyfill's default behaviour is to disable itself in browsers with native `position: sticky`
       support.  However, for sites using the WhatsIncluded component, the body element should have
       the styling `overflow-x: hidden`, which breaks `position: sticky` styling, so we use this to 
       polyfill sticky everywhere.

       The following line can be removed once confident that no site using the component library relies
       on overflow styling that breaks `sticky` components, such as the InPageNav component.
    */
    Stickyfill.forceSticky();

    const addStickyToElement = (): void => {
      if (!refElement.current) {
        return;
      }
      Stickyfill.addOne(refElement.current);
    };

    const removeStickyFromElement = (): void => {
      if (!refElement.current) {
        return;
      }
      Stickyfill.removeOne(refElement.current);
    };

    addStickyToElement();
    return () => removeStickyFromElement();
  }, [refElement]);
};
